// Images and URLs for the slides.

export const carouselData = [
    {
        name: "Kairos Investment",
        fileName: "kairosInvestment",
        url: "https://www.kairos.co.kr",
    },
    {
        name: "Strategic Ventures",
        fileName: "SVstrategicVentrues1",
        url: "http://svrglobal.com",
    },
    {
        name: "NYSERDA",
        fileName: "NYStatelogo",
        url: "https://www.nyserda.ny.gov",
    },
    {
        name: "SOSV",
        fileName: "SOSVlogo",
        url: "https://sosv.com",
    },
    {
        name: "USRuralDepartmentPACE",
        fileName: "USRuralDepartmentPACE",
        url: "https://www.rd.usda.gov/programs-services/electric-programs/powering-affordable-clean-energy-pace-program",
    },
    {
        name: "breezm",
        fileName: "breezm",
        url: "https://www.breezmeyewear.com/",
    },
    {
        name: "eia",
        fileName: "eia",
        url: "https://www.eia.gov/",
    },
    {
        name: "gdi",
        fileName: "gdi",
        url: "https://www.gdinrg.com/",
    },
    {
        name: "jellatech",
        fileName: "jellatech",
        url: "https://www.jellatech.com/",
    },
    {
        name: "kolmar1",
        fileName: "kolmar1",
        url: "https://www.kolmar.co.kr/eng/",
    },
    {
        name: "modernmeadow",
        fileName: "modernmeadow",
        url: "https://www.modernmeadow.com/",
    },
    {
        name: "newharvestlogo",
        fileName: "newharvestlogo",
        url: "https://new-harvest.org/",
    },
    {
        name: "nybest1",
        fileName: "nybest1",
        url: "https://ny-best.org/",
    },
    {
        name: "plyoneer",
        fileName: "plyoneer",
        url: "http://www.zeeing.io/",
    },
    {
        name: "PowertoHydrogen1",
        fileName: "PowertoHydrogen1",
        url: "https://power-h2.com/",
    },
    {
        name: "seawith1",
        fileName: "seawith1",
        url: "http://seawith.info/",
    },
    {
        name: "Unigen-Logo1",
        fileName: "Unigen-Logo1",
        url: "https://unigen.net/",
    },
    {
        name: "IEExpo",
        fileName: "IEExpo",
        url: "https://www.ie-expo.com/",
    },
    {
        name: "supplysidewest",
        fileName: "supplysidewest",
        url: "https://west.supplysideshow.com/en/home.html",
    },
    {
        name: "incosmetics",
        fileName: "incosmetics",
        url: "https://www.in-cosmetics.com",
    },
    {
        name: "newyorkchemists",
        fileName: "newyorkchemists",
        url: "https://nyscc.org/",
    },
    {
        name: "cosmoprof",
        fileName: "cosmoprof",
        url: "https://www.cosmoprofbeauty.com/",
    },
    {
        name: "aquatech",
        fileName: "aquatech",
        url: "https://www.aquatechtrade.com/",
    },
    {
        name: "soliome",
        fileName: "soliome",
        url: "https://soliome.com/",
    },
    {
        name: "livingfuture",
        fileName: "livingfuture",
        url: "https://living-future.org/",
    },
];
